import { Link } from 'react-router-dom';
import type { FC } from 'react';

const CTASection: FC = () => {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="relative rounded-lg bg-accent-50 border border-accent-200 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20abstract%20soft%20gradient%20in%20gentle%20teal%20and%20cream%20tones%2C%20smooth%20flowing%20geometric%20shapes%2C%20clean%20spacious%20composition%2C%20calm%20and%20inviting%20technology%20aesthetic%2C%20subtle%20luminous%20quality%2C%20light%20airy%20atmosphere&width=1200&height=400&seq=cta-17c-2026&orientation=landscape"
            alt=""
            className="absolute inset-0 w-full h-full object-cover opacity-40"
          />
          <div className="relative z-10 text-center py-12 md:py-16 px-6 md:px-10">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
              准备好开始您的 17c.com 之旅了吗？
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-700 max-w-lg mx-auto">
              立即注册 17c.com，免费体验平台全部核心功能，开启高效数字化工作新方式
            </p>
            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/user-guide"
                className="px-8 py-3.5 bg-primary-500 text-background-50 font-medium rounded-md text-sm whitespace-nowrap hover:bg-primary-600 transition-colors duration-200 cursor-pointer w-full sm:w-auto"
              >
                免费注册账号
              </Link>
              <Link
                to="/about"
                className="px-8 py-3.5 bg-background-50 text-foreground-800 font-medium rounded-md text-sm whitespace-nowrap hover:bg-background-100 transition-colors duration-200 cursor-pointer border border-background-300/60 w-full sm:w-auto"
              >
                了解更多
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;